module.exports = __webpack_public_path__ + "static/media/fridgeful.9505be95.png";